import './styles/app.scss'

import { environment } from '@/environments/environment'
import Vue from 'vue'

import App from '@/App.vue'
import getRouter from '@/router'
import store from '@/store'

import { applyPolyfills, defineCustomElements } from '@fiizy/stylebook/loader'
import { FormRequestFields } from '@/models'
import { mapToFormRequestFields } from '@/utils/helpers'
import { eventbus } from '@fiizy/utils'

interface AppDataSet extends DOMStringMap {
  channelHash?: string
  landingPageChannelHash?: string
  seoChannelHash?: string
  forceChannel?: string
  locale?: string
  language?: string
  clientBundleIdentifier?: string
  loanType?: string
  cdnPath?: string
  fullScreen?: string
  mountEvent?: string
}

Vue.config.ignoredElements = [/fi-\w*/]

applyPolyfills().then(() => {
  defineCustomElements()
})

const mount = document.querySelectorAll(`div[${environment.ATTACH_ATTRIBUTE}]`)

mount.forEach((elem) => {
  const element = elem as HTMLElement

  // read data form attributes
  const dataset = element.dataset as AppDataSet

  // filter out form data from dataset, also remove form action and mode
  const formDataset = [...Object.entries(element.dataset)].filter((item) => !item[0].indexOf('form'))

  const form: FormRequestFields = mapToFormRequestFields(formDataset)

  const router = getRouter(element.dataset.base || '')

  const bus = eventbus(environment.EVENT_CHANNEL || 'c432556660722ff93cefb5a932e550b7')

  bus.on('app:router:push', (event: CustomEvent) => {
    router.push(event.detail)
  })

  // eslint-disable-next-line no-new
  new Vue({
    router,
    store,
    created() {
      if (dataset.mountEvent && dataset.mountEvent === 'true') {
        window.addEventListener('fi-app-init', this.load)
        window.dispatchEvent(new Event('fi-app-created'))
      } else {
        this.load()
      }
    },
    methods: {
      load() {
        this.$mount(element)
      }
    },
    render: (h) => {
      return h(App, {
        props: {
          channelHash: dataset.channelHash || '',
          landingPageChannelHash: dataset.landingPageChannelHash || '',
          seoChannelHash: dataset.seoChannelHash || '',
          forceChannel: dataset.forceChannel === 'true',
          language: dataset.language || '',
          locale: dataset.locale || 'en-US',
          clientBundleIdentifier: dataset.clientBundleIdentifier || '',
          cdnPath: dataset.cdnPath || '',
          fullScreen: dataset.fullScreen === 'true',
          form
        }
      })
    }
  })
})
